export default "__VITE_ASSET__Bg94h7$s__"